"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Icons = _interopRequireDefault(require("../Icons"));

var _withTheme = require("../../wrappers/with-theme");

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var NavItem = function NavItem(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      to = _ref.to,
      onClick = _ref.onClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "side" : _ref$type,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$subMenus = _ref.subMenus,
      subMenus = _ref$subMenus === void 0 ? [] : _ref$subMenus;
  var theme = (0, _withTheme.useTheme)();
  var history = (0, _reactRouterDom.useHistory)();

  var To = _react["default"].useMemo(function () {
    if (!Array.isArray(to)) {
      return [to];
    }

    return to;
  }, [to]);

  var subTos = _react["default"].useMemo(function () {
    var subs = subMenus.reduce(function (a, c) {
      if (Array.isArray(c.path)) {
        a.push.apply(a, _toConsumableArray(c.path));
      } else if (c.path) {
        a.push(c.path);
      }

      return a;
    }, []);
    return [].concat(_toConsumableArray(To), _toConsumableArray(subs));
  }, [To, subMenus]);

  var routeMatch = Boolean((0, _reactRouterDom.useRouteMatch)({
    path: subTos,
    exact: true
  }));
  var linkClasses = type === "side" ? theme.navitemSide : theme.navitemTop;
  var activeClasses = type === "side" ? theme.navitemSideActive : theme.navitemTopActive;
  var navClass = routeMatch || active ? activeClasses : linkClasses;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showSubMenu = _React$useState2[0],
      setShowSubMenu = _React$useState2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick ? onClick : function () {
      if (To[0]) {
        history.push(To[0]);
      }
    },
    className: "".concat(className ? className : navClass),
    onMouseLeave: function onMouseLeave(e) {
      return setShowSubMenu(false);
    },
    onMouseOver: function onMouseOver(e) {
      return setShowSubMenu(true);
    }
  }, !icon ? null : /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    icon: icon,
    className: type === "side" ? theme.menuIconSide : theme.menuIconTop
  }), children, /*#__PURE__*/_react["default"].createElement(SubMenu, {
    showSubMenu: showSubMenu,
    subMenus: subMenus,
    type: type
  }));
};

var _default = NavItem;
exports["default"] = _default;

var SubMenu = function SubMenu(_ref2) {
  var showSubMenu = _ref2.showSubMenu,
      subMenus = _ref2.subMenus,
      type = _ref2.type;
  var theme = (0, _withTheme.useTheme)();

  if (!showSubMenu || !subMenus.length) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute ".concat(type === "side" ? "pt-1 -mt-14 left-full" : "top-full")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n\t\t\t\t\t\tflex whitespace-nowrap\n\t\t\t\t\t\t".concat(type === "side" ? "flex-col" : "flex-row", "\n\t\t\t\t\t"),
    style: {
      minWidth: type === "top" ? null : "".concat(+(0, _lodash["default"])(theme, "sidebarW", 64) * 0.25, "rem")
    }
  }, subMenus.map(function (sm, i) {
    return /*#__PURE__*/_react["default"].createElement(NavItem, {
      key: i,
      to: sm.path,
      icon: sm.icon,
      type: type
    }, sm.name);
  }))));
};